import { MetricConverter } from './helpers';

const CapacitanceUnits = ['uF', 'mF', 'F'] as const;
type TCapacitanceUnit = (typeof CapacitanceUnits)[number];

class CapacitanceConverter extends MetricConverter<TCapacitanceUnit, 'F'> {
    baseUnit = 'F' as const;
    units = CapacitanceUnits;
}

export const capacitanceConverter = new CapacitanceConverter();
